export const INDIAN_MOBILE_PATTERN = /^[6-9]\d{9}$/;

const stripRecognizedIndianPrefix = (digits) => {
  const prefixedFormats = [
    { prefix: "0091", totalLength: 14 },
    { prefix: "91", totalLength: 12 },
    { prefix: "0", totalLength: 11 },
  ];

  for (const { prefix, totalLength } of prefixedFormats) {
    if (digits.length !== totalLength || !digits.startsWith(prefix)) continue;

    const nationalNumber = digits.slice(prefix.length);
    if (INDIAN_MOBILE_PATTERN.test(nationalNumber)) return nationalNumber;
  }

  return digits;
};

export const normalizeIndianMobileInput = (value) => {
  const digits = String(value ?? "").replace(/\D/g, "");
  return stripRecognizedIndianPrefix(digits);
};

export const isValidIndianMobile = (value) =>
  INDIAN_MOBILE_PATTERN.test(normalizeIndianMobileInput(value));
